import {
    GetObjectCommand,
    ListBucketsCommand,
    ListObjectsCommand, ListObjectsV2Command,
    PutObjectCommand,
    S3Client,
    S3ClientConfig
} from "@aws-sdk/client-s3";
import {getAllNoteList, getDoc, getNoteDoc, getNoteList, updateNote} from "../../model";
import global from "../global"
import {getClient} from "./Aws";
import {command} from "@tiptap/core/dist/packages/core/src/commands";
import {EVENT_NOTE_CHANGED, EVENT_UPDATE_NOTE, KEY_FILE_DIR} from "@/Const";
import {postMessage} from "@/common/event";
import {blobToBase64, getFileNameExt, getMindmapFiles, isFileElement, isStringNullOrEmpty} from "@/utils";
import {ipcInvoke} from "@/common/ipc";
import {constBase64ToFileBlob} from "../../@excalidraw/packages/excalidraw/data/blob";
import {message} from "antd";
import {imgServer} from "@/components/EditorV2/imgServer";
import {DEBUG} from "@/electron_interactive";
import {isMindmapElement} from "../../@excalidraw/packages/excalidraw/element/typeChecks";
export const AWS_S3_PRE_DATA_URL = "https://muenzo-data.s3.amazonaws.com/sync/";
const REGION = "us-east-1";

let mDownloadSize = 0;
let mUploadSize = 0;

function logMessage(szMessage:string){
    if (DEBUG){
        console.log('***************');
        console.log(szMessage)
        console.log('***************')
    }
}

export async function syncS3(progressCallback:any) {
    // const client = getClient();
    //1.first 打包基础all数据
    let arrayLocalCanvas: any = await getAllNoteList();
    const CANVAS_PATH_DATA = 'sync/' + global.g_userInfo?.id + '/canvas-list';
    const THUMB_DIR = 'sync/' + global.g_userInfo?.id + '/thumb/';
    const DOC_DIR = 'sync/' + global.g_userInfo?.id + '/doc/';

    mDownloadSize = 0;
    mUploadSize = 0;
    const TOTAL_STEP = 4;

    try {
        //2.remote list-数据
        let jsonRemoteCanvas: any = await getS3JsonData(CANVAS_PATH_DATA);
        if (jsonRemoteCanvas) {
            //待更新到DB的数据
            // const arrayForUpdateToDb:any[] = [];
            //远程有数据...
            for (let i = 0; i < jsonRemoteCanvas.length; i++) {
                const remoteCanvas = jsonRemoteCanvas[i];
                //逐个与本地比较
                const localCanvas = getLocalCanvasByRemoteCanvas(remoteCanvas, arrayLocalCanvas);
                if (localCanvas) {//存在，并且非删除
                    let jsonLocalDoc = await getNoteDoc(arrayLocalCanvas[i].id);
                    jsonLocalDoc = JSON.parse(jsonLocalDoc.doc);

                    //本地对象也存在，比较最后更新日期--远程的是最新的。。。。
                    if (localCanvas.updateTime < remoteCanvas.updateTime) {
                        //region 用远程的更新本地的...
                        //1.获取缩略图
                        remoteCanvas.img = await getS3StringData(THUMB_DIR + remoteCanvas.id);
                        //2.获取doc.
                        const REMOTE_DOC_DIR = DOC_DIR + remoteCanvas.id;
                        const REMOTE_DOC_DATA = REMOTE_DOC_DIR + '/data'
                        const REMOTE_DOC_FILE_DIR = REMOTE_DOC_DIR + "/files/";
                        const REMOTE_DOC_NOTE_DIR = REMOTE_DOC_DATA + "/notes/";

                        logMessage('get remote doc data...');
                        let jsonRemoteDoc: any = await getS3JsonData(REMOTE_DOC_DATA);

                        if (jsonRemoteDoc) {
                            for (let j = 0; j < jsonRemoteDoc.length; j++) {
                                //region 图片files
                                const remoteFiles = jsonRemoteDoc[j].drawJson.files;
                                const arrayFileKeys = Object.keys(remoteFiles);
                                for (let nFile = 0; nFile < arrayFileKeys.length; nFile++) {
                                    const szKey = arrayFileKeys[nFile];
                                    const localFile = getLocalImageFile(szKey, jsonLocalDoc);
                                    if (localFile) {
                                        remoteFiles[szKey] = localFile[szKey];
                                    } else {
                                        //本地不存在，下载
                                        remoteFiles[szKey] = await getS3JsonData(REMOTE_DOC_FILE_DIR + szKey)
                                    }
                                }
                                //endregion
                            }

                            //文件....
                            for (let j=0;j<jsonRemoteDoc.canvas.length;j++){
                                const canvasItem = jsonRemoteDoc.canvas[j];
                                for (let k=0;k<canvasItem.drawJson.elements.length;k++){
                                    const element = canvasItem.drawJson.elements[k];
                                    if (isFileElement(element)){
                                        //如果本地文件存在就不用下载了...
                                        const localFile = getLocalFile(element,jsonLocalDoc);
                                        if (!localFile){
                                            //下载并保存成文件...
                                            const fileBuf = await getS3StringData(REMOTE_DOC_FILE_DIR+element.id);
                                            // const szBase64File = (fileBuf);
                                            var item = {
                                                fileName:element.customData.generationData.fileName,
                                                data:fileBuf
                                            }
                                            await ipcInvoke('write-buffer-files',JSON.stringify([item]));
                                        }
                                    }
                                }
                            }

                            //notes
                            const remoteNotes = jsonRemoteDoc.notes;
                            for (let j = 0; j < remoteNotes.length; j++) {
                                //region notes
                                const remoteNote = remoteNotes[j];
                                const localNote = getLocalNotes(remoteNote.key, jsonLocalDoc.notes);
                                if (localNote && localNote.updateTime > remoteNote.updateTime) {
                                    //使用本地替换远程端的。不用下载了。。
                                    remoteNote.updateTime = localNote.updateTime;
                                    remoteNote.noteDataDoc = localNote.noteDataDoc;
                                } else {
                                    //下载noteDataDoc
                                    let szRemoteNoteDataDoc = await getS3StringData(REMOTE_DOC_NOTE_DIR + remoteNote.key);
                                    remoteNote.noteDataDoc = szRemoteNoteDataDoc;
                                    //获取note-image..看看是否需要下载....
                                    const arrayNoteImages = await getOneNotesImages(remoteNote.noteDataDoc);
                                    for (let nImg=0;nImg < arrayNoteImages.length;nImg++){
                                        const imgItem = arrayNoteImages[nImg];
                                        if (isStringNullOrEmpty(imgItem.data)){
                                            //本地没有....要下载
                                            let jsonImageData = await getS3JsonData(REMOTE_DOC_FILE_DIR+imgItem.id);
                                            //保存本地文件
                                            ipcInvoke('save-image-to-local',JSON.stringify([jsonImageData]));
                                        }
                                    }
                                }
                                //endregion
                            }
                        }
                        //endregion

                        //用远程的更新.
                        remoteCanvas.doc = JSON.stringify(jsonRemoteDoc);
                        await updateNote(remoteCanvas)
                    }
                } else {
                    //region 本地不存在全部使用远程的新建
                    //1.获取缩略图
                    remoteCanvas.img = await getS3StringData(THUMB_DIR + remoteCanvas.id);

                    //2.获取doc.
                    const REMOTE_DOC_DIR = DOC_DIR + remoteCanvas.id;
                    const REMOTE_DOC_FILE_DIR = REMOTE_DOC_DIR + "/files/";
                    const REMOTE_DOC_NOTE_DIR = REMOTE_DOC_DIR + "/notes/";
                    let jsonRemoteDoc: any = await getS3JsonData(REMOTE_DOC_DIR + "/data");
                    if (jsonRemoteDoc) {
                        for (let j = 0; j < jsonRemoteDoc.canvas.length; j++) {
                            //region files
                            const remoteFiles = jsonRemoteDoc.canvas[j].drawJson.files;
                            const arrayFileKeys = Object.keys(remoteFiles);
                            for (let nFile = 0; nFile < arrayFileKeys.length; nFile++) {
                                const szKey = arrayFileKeys[nFile];
                                //本地不存在，下载
                                remoteFiles[szKey] = await getS3JsonData(REMOTE_DOC_FILE_DIR + szKey)
                            }
                            //endregion
                        }

                        //文件....
                        for (let j=0;j<jsonRemoteDoc.canvas.length;j++){
                            const canvasItem = jsonRemoteDoc.canvas[j];
                            for (let k=0;k<canvasItem.drawJson.elements.length;k++){
                                const element = canvasItem.drawJson.elements[k];
                                if (isFileElement(element)){
                                    //下载并保存成文件...
                                    const fileBuf = await getS3StreamData(REMOTE_DOC_FILE_DIR+element.id);
                                    const szBase64File:any = uint8ArrayToBase64(fileBuf);
                                    if (!isStringNullOrEmpty(szBase64File)){
                                        var item0 = {
                                            fileName:element.customData.generationData.fileName,
                                            data:szBase64File
                                        }
                                        await ipcInvoke('write-base64-files',JSON.stringify([item0]));
                                    }
                                }
                            }
                        }

                        //notes
                        const remoteNotes = jsonRemoteDoc.notes;
                        for (let j = 0; j < remoteNotes.length; j++) {
                            //region notes
                            const remoteNote = remoteNotes[j];
                            //下载noteDataDoc
                            let szRemoteNoteDataDoc = await getS3StringData(REMOTE_DOC_NOTE_DIR + remoteNote.key);
                            remoteNote.noteDataDoc = szRemoteNoteDataDoc;

                            //获取note-image..看看是否需要下载....
                            const arrayNoteImages = await getOneNotesImages(remoteNote.noteDataDoc);
                            for (let nImg=0;nImg < arrayNoteImages.length;nImg++){
                                const imgItem = arrayNoteImages[nImg];
                                if (isStringNullOrEmpty(imgItem.data)){
                                    //本地没有....要下载
                                    let jsonImageData = await getS3JsonData(REMOTE_DOC_FILE_DIR+imgItem.id);
                                    //保存本地文件
                                    ipcInvoke('save-image-to-local',JSON.stringify([jsonImageData]));
                                }
                            }
                            //endregion
                        }
                    }
                    //endregion

                    remoteCanvas.doc = JSON.stringify(jsonRemoteDoc);
                    //保存
                    await updateNote(remoteCanvas);
                }
            }
            //更新首页
            postMessage(EVENT_NOTE_CHANGED);
        }

        //取消同步了，这里不上传。。。只在几个特定点允许取消
        if (!global.g_isSyncing) return "canceled";

        //region****** 数据合并完毕。全部上传本地的******
        logMessage('data merge finished...waiting upload...');

        //再次取本地全部数据....
        arrayLocalCanvas = await getAllNoteList();
        //1.缩略图单独取出*********
        let arrayThumbs: any[] = [];
        for (let i = 0; i < arrayLocalCanvas.length; i++) {
            if (arrayLocalCanvas[i].isDeleted == 1) {
                arrayLocalCanvas[i].img = '';
                continue;
            }
            arrayThumbs.push({
                id: arrayLocalCanvas[i].id,
                img: arrayLocalCanvas[i].img
            })
            arrayLocalCanvas[i].img = '';
        }
        const szLocalCanvas = JSON.stringify(arrayLocalCanvas)
        const putCommand = new PutObjectCommand({
            Bucket: 'muenzo-data',
            Key: CANVAS_PATH_DATA,
            Body: szLocalCanvas
        })
        mUploadSize += szLocalCanvas.length;

        logMessage('upload local finaly data...');
        await getClient().send(putCommand);

        //进度...
        progressCallback(1/TOTAL_STEP);

        //2.单独上传每个canvas的首页缩略图...
        let arrayPutThumbs = [];
        for (let i = 0; i < arrayThumbs.length; i++) {
            const putCmd = new PutObjectCommand({
                Bucket: 'muenzo-data',
                Key: THUMB_DIR + arrayThumbs[i].id,
                Body: arrayThumbs[i].img
            })
            mUploadSize += arrayThumbs[i].img?.length;

            arrayPutThumbs.push(putCmd);
        }
        await Promise.all(arrayPutThumbs.map((command) => getClient().send(command).catch((err) => {
            return null;
        }))).then((res) => {
            console.log('put image thumb success...')
        }).catch((error) => {
            console.error('put image thumb error files:' + error);
        });
        //进度...
        progressCallback(2/TOTAL_STEP);

        //3.获取所有实际的数据DOC
        let arrayPutCommands = [];
        let arrayPutDocs = [];
        for (let i = 0; i < arrayLocalCanvas.length; i++) {
            if (arrayLocalCanvas[i].isDeleted) continue;
            const doc = await getNoteDoc(arrayLocalCanvas[i].id);
            //第一项DOC的路径
            const DOC_PATH = DOC_DIR + arrayLocalCanvas[i].id;
            const DOC_DATA_PATH = DOC_PATH + "/data";
            const NOTES_DIR = DOC_PATH + '/notes/';
            const FILE_DIR = DOC_PATH + '/files/';

            const jsonDoc = JSON.parse(doc.doc);
            // jsonDoc.annotations,jsonDoc.canvas,jsonDoc.info,jsonDoc.notes,jsonDoc.pageSize;
            //拆分canvas/files -notes
            const canvas = jsonDoc.canvas;

            let arrayRemoteFileList: any = null;
            let listFileCmd = new ListObjectsV2Command({
                Bucket: 'muenzo-data',
                Prefix: FILE_DIR,
                MaxKeys: 1000
            });
            let arrayListBuckets = await getClient().send(listFileCmd);
            arrayRemoteFileList = arrayListBuckets.Contents ?? [];

            for (let j = 0; j < canvas.length; j++) {
                const canvasItem = canvas[j];
                //图片部分
                const files = canvas[j].drawJson.files;
                const arrayFileKeys = Object.keys(files);
                for (let k = 0; k < arrayFileKeys.length; k++) {
                    const szKey = arrayFileKeys[k];
                    const isRemoteFileExist = arrayRemoteFileList.some(p => p.Key.endsWith(szKey));
                    if (!isRemoteFileExist) {
                        const szFile = JSON.stringify(files[szKey]);
                        const putCmd = new PutObjectCommand({
                            Bucket: 'muenzo-data',
                            Key: FILE_DIR + szKey,
                            Body: szFile
                        })
                        arrayPutCommands.push(putCmd);
                        mUploadSize += szFile.length;
                    }

                    //清空value
                    files[szKey] = {};
                }

                //清空file...
                // canvas[j].drawJson.files = {};
                //清空subNotes
                canvas[j].subNotes = [];
            }

            //文件部分 -- 文件。不是图片....
            const arrayFiles = await getFileBase64ForExport(canvas);
            for (let nFile=0;nFile < arrayFiles.length;nFile++){
                const item = arrayFiles[nFile];
                const isRemoteFileExist = arrayRemoteFileList.some(p => p.Key.endsWith(item.id));
                if (!isRemoteFileExist) {
                    const buffer = await constBase64ToFileBlob(item.data,item.fileName);
                    //添加到command
                    const command = new PutObjectCommand({
                        Bucket:'muenzo-data',
                        Key:FILE_DIR+item.id,
                        Body:buffer
                    })
                    mUploadSize += item.data.length;
                    arrayPutCommands.push(command);
                }
            }

            //上传notes-将笔记部分单独上传
            let arrayRemoteNotesList: any = null;
            let listNotesCmd = new ListObjectsV2Command({
                Bucket: 'muenzo-data',
                Prefix: NOTES_DIR,
                MaxKeys: 1000
            });
            arrayListBuckets = await getClient().send(listNotesCmd);
            arrayRemoteNotesList = arrayListBuckets.Contents ?? [];

            const notes = jsonDoc.notes;
            //********笔记图片********
            const arrayNotesImages = await getNotesImage(notes);
            for (let i=0;i<arrayNotesImages.length;i++){
                const item = arrayNotesImages[i];
                const isRemoteFileExist = arrayRemoteFileList.some(p => p.Key.endsWith(item.id));
                if (!isRemoteFileExist) {
                    //添加到command
                    const szJson = JSON.stringify(item);
                    const command = new PutObjectCommand({
                        Bucket:'muenzo-data',
                        Key:FILE_DIR+item.id,
                        Body:szJson
                    })
                    mUploadSize += item.data.length;
                    arrayPutCommands.push(command);
                }
            }

            //笔记内容
            for (let j = 0; j < notes.length; j++) {
                const szKey = notes[j].key;
                const isRemoteNoteExist = arrayRemoteNotesList.some(p => p.Key.endsWith(szKey));
                if (!isRemoteNoteExist) {
                    //远程不存在，需要上传
                    const putCmd = new PutObjectCommand({
                        Bucket: 'muenzo-data',
                        Key: NOTES_DIR + szKey,
                        Body: notes[j].noteDataDoc
                    })
                    arrayPutCommands.push(putCmd);
                    mUploadSize += notes[j].noteDataDoc.length;
                }

                notes[j].noteDataDoc = "";
            }
            // let putCmd = new PutObjectCommand({
            //     Bucket:'muenzo-data',
            //     Key:NOTES_DIR+"notes",
            //     Body:JSON.stringify(notes)
            // })
            // arrayPutCommands.push(putCmd);

            //清空，作整体上传---
            // jsonDoc.canvas = [];
            // jsonDoc.notes = [];

            const szJsonDoc = JSON.stringify(jsonDoc)
            let putCmd = new PutObjectCommand({
                Bucket: 'muenzo-data',
                Key: DOC_DATA_PATH,
                Body: szJsonDoc
            })
            arrayPutCommands.push(putCmd);
            mUploadSize += szJsonDoc.length;
        }

        //进度...
        progressCallback(3/TOTAL_STEP);

        await Promise.all(arrayPutCommands.map((command) => getClient().send(command).catch((err) => {
            return null;
        }))).then((res) => {
            console.log('put doc success...')
        }).catch((error) => {
            console.error('put doc error:' + error);
        });
        //endregion

        //进度...
        progressCallback(4/TOTAL_STEP);


        mUploadSize = mUploadSize*0.5;
        mUploadSize /= 1024;//kb
        let mSize = Math.floor(mUploadSize)+'Kb';
        if (mUploadSize > 1024){
            mSize = Math.floor(mUploadSize/1024)+'Mb';
        }

        mDownloadSize = mDownloadSize*0.5;
        mDownloadSize /= 1024;//kb
        let szDownloadSize = Math.floor(mDownloadSize)+'Kb';
        if (mDownloadSize > 1024){
            szDownloadSize = Math.floor(mDownloadSize/1024)+'Mb';
        }
        message.info('上传流量:'+mSize + '\n下载流量:'+szDownloadSize,8)

        return "success";
    }
    catch (e) {
        if (DEBUG){
            throw e;
        }
        console.log('sync fail:'+e);
        return "fail";
    }finally {

    }
}

/**
 * 所有文件集合
 * @param canvas
 */
async function getFileBase64ForExport(canvas:any){
    let arrayFiles:any = [];
    for (let i=0;i<canvas.length;i++){
        for (let j=0;j<canvas[i].drawJson.elements.length;j++){
            const element = canvas[i].drawJson.elements[j];
            if (isFileElement(element)){
                const data = await getFileBase64(localStorage.getItem(KEY_FILE_DIR) + element?.customData?.generationData?.fileName);
                arrayFiles.push({
                    id:element.id,
                    data:data,
                    fileName:element?.customData?.generationData?.fileName,
                    ext:getFileNameExt(element?.customData?.generationData?.fileName)
                });
            }else if (isMindmapElement(element)){
                const arrayMindmapFiles = getMindmapFiles(element.data);
                for (let k=0;k<arrayMindmapFiles.length;k++){
                    const item = arrayMindmapFiles[k];
                    const data = await getFileBase64(localStorage.getItem(KEY_FILE_DIR) + item.fileName);
                    arrayFiles.push({
                        id:item.id,
                        data:data,
                        fileName:item.fileName,
                        ext:getFileNameExt(item.fileName)
                    })
                }
            }
        }
    }
    return arrayFiles;
}

/**
 * 文件base64
 * @param szFilePath
 */
function getFileBase64(szFilePath:string){
    return new Promise((resolve, reject) => {
        ipcInvoke("read-file-base64",{filePath:szFilePath}).then(res=>{
            resolve(res);
        })
    })
}

/**
 * 获取所有笔记中的图片
 * @param notes
 */
const getNotesImage = async (notes:any)=>{
    let notesImg = [];
    for (let i=0;i<notes.length;i++){
        const item = notes[i];
        if (item.isFolder){
            for (let j=0;j<item.children.length;j++){
                let imgs = await imgServer.getImgFromSystem(item.children[j].noteDataDoc);
                notesImg.push(...imgs);
            }
        }else{
            let imgs = await imgServer.getImgFromSystem(item.noteDataDoc);
            notesImg.push(...imgs);
        }
    }
    return notesImg;
}

const getOneNotesImages = async (noteDataDoc:any)=>{
    let imgs = await imgServer.getImgFromSystem(noteDataDoc);
    return imgs;
}

/**
 * 直接获取s3的JSON对象
 * @param client
 * @param szPath
 */
async function getS3JsonData(szPath:string){
    let getCmd = new GetObjectCommand({
        Bucket:'muenzo-data',
        Key:szPath,
    })
    let jsonData = null;
    try{
        const { Body } = await getClient().send(getCmd);
        const szRemoteData = await Body.transformToString();
        mDownloadSize += szRemoteData.length;
        jsonData = JSON.parse(szRemoteData);
    }catch (e) {
        console.log(szPath+"****"+e);
    }
    return jsonData;
}
async function getS3StringData(szPath:string){
    let getCmd = new GetObjectCommand({
        Bucket:'muenzo-data',
        Key:szPath,
    })
    let szData = null;
    try{
        const { Body } = await getClient().send(getCmd);
        szData = await Body.transformToString();
        mDownloadSize += szData.length;
    }catch (e) {
        console.log(szPath+"****"+e);
    }
    return szData;
}
async function getS3StreamData(szPath:string){
    let getCmd = new GetObjectCommand({
        Bucket:'muenzo-data',
        Key:szPath,
    })
    let szData = null;
    try{
        const { Body } = await getClient().send(getCmd);
        szData = await Body.transformToByteArray();
        mDownloadSize += szData.length;
    }catch (e) {
        console.log(szPath+"****"+e);
    }
    return szData;
}
function uint8ArrayToBase64(u8Array:any) {
    let binaryString = '';
    if (u8Array){
        for (let i = 0; i < u8Array.length; i++) {
            binaryString += String.fromCharCode(u8Array[i]);
        }
        // 对二进制字符串进行base64编码
        const base64 = btoa(binaryString);
        return base64;
    }
    return null;
}

/**
 * 远程和本地的元素
 * @param remoteCanvas
 * @param arrayLocalCanvas
 */
function getLocalCanvasByRemoteCanvas(remoteCanvas:any,arrayLocalCanvas:any[]){
    var arrayItems = arrayLocalCanvas.filter(p=>p.id == remoteCanvas.id);
    if (arrayItems && arrayItems.length > 0){
        return arrayItems[0];
    }
    return null;
}

/**
 * 由远程文件的KEY  看看本地是否有
 * @param remoteFileKey
 * @param jsonLocalDoc
 */
function getLocalImageFile(remoteFileKey:any,jsonLocalDoc:any){
    for (let i=0;i<jsonLocalDoc.canvas.length;i++){
        const localFiles = jsonLocalDoc[i].drawJson.files;
        const file = localFiles[remoteFileKey];
        if (file){
            return file;
        }
    }
    return null;
}

/**
 * 由远程文件的KEY  看看本地是否有
 * @param remoteFileKey
 * @param jsonLocalDoc
 */
function getLocalFile(remoteElementId:any,jsonLocalDoc:any){
    for (let i=0;i<jsonLocalDoc.canvas.length;i++){
        const elements = jsonLocalDoc[i].drawJson.elements;
        for (let j=0;j<elements.length;j++){
            const element = elements[j];
            if (element.id == remoteElementId){
                return element;
            }
        }
    }
    return null;
}

/**
 * 由远程笔记key 查本地note
 * @param remoteNotesKey
 * @param arrayLocalNotes
 */
function getLocalNotes(remoteNotesKey:any,arrayLocalNotes:any[]){
    for (let i=0;i<arrayLocalNotes.length;i++){
        const note = arrayLocalNotes[i];
        if (remoteNotesKey == note.key){
            return note;
        }
    }
    return null;
}

































